import { Spinner } from "reactstrap";
import './index.scss';
const Preloader = () => {
  return <div className="pre-loader-container">
    <Spinner animation="grow" />;
  </div>
};

export default Preloader;
